import React, { useState } from 'react';

import Toggle from 'eymp-uicomps/components/Toggle';
import './ToggleWithLabels.scss';

function ToggleWithLabels(props) {
  const { onLabel, offLabel } = props;
  const [defaultToggle, setDefaultToggle] = useState(props.switchSelected);
  const changeHandler = event => {
    if (event) {
      setDefaultToggle(event.target.value);
      if (props && typeof props.onChange == 'function') {
        props.onChange(event.target.value);
      }
    }
  };
  return (
    <div className="toggleWithLabels">
      <div item xs={12} md={12}>
        <Toggle
          aria-labelledby="custom-labels-example"
          checked={defaultToggle}
          onLabel={onLabel}
          offLabel={offLabel}
          // onLabel="All cases"
          // offLabel="My cases"
          onChange={event => changeHandler(event)}
        />
      </div>
    </div>
  );
}

export default ToggleWithLabels;
